/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServePublicRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllCollectionsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.SelfServePublicRpc',
  rpcName: 'getAllCollections',
  auth: 'external',
  fingerprint: 'AAAAAAAAAABkffZSWUX1AJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllPublishedCollectionsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.SelfServePublicRpc',
  rpcName: 'getAllPublishedCollections',
  auth: 'external',
  fingerprint: 'AAAAAAAAAABkffZSWUX1AJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};